import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button"
import { useRole } from "@/hooks/use-role";

export function NavLinks() {
  const location = useLocation();
  const { isAdmin } = useRole();

  const links = [
    { path: "/admin", label: "Dashboard" },
    { path: "/admin/monitoring", label: "Monitoramento" },
  ]

  return (
    <div className="flex items-center">
      <div className="mr-8">
        <img src="/logo.png" alt="logo" className="h-[35px]" />
      </div>
      <div className="flex items-center gap-3">
        {isAdmin && links.map(item => (
          <Link key={item.path} to={item.path}>
            <Button key={item.path} variant={location.pathname === item.path ? "secondary" : "ghost"} className={`cursor-pointer ${location.pathname === item.path ? "text-[#000]" : "text-[#707070]"}`}>{item.label}</Button>
          </Link>
        ))}
      </div>
    </div>
  )
}